import React from "react";
import Settings from "./components/Settings";
import "./styles/settingsStyles.css";

const SettingsApp = (props) => <Settings {...props} />;

export default SettingsApp;
